import React, { memo, useContext } from 'react';
import Radio from './radio';
import RadioContext from './RadioContext';
const RadioButton = function (props) {
    const { radioGroup, getPrefixCls } = useContext(RadioContext);
    const radioProps = { ...props };
    if (radioGroup) {
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
    }
    return React.createElement(Radio, Object.assign({ prefixCls: getPrefixCls('radio-button') }, radioProps));
};
RadioButton.displayName = 'RadioButton';
export default memo(RadioButton);
